import { render, staticRenderFns } from "./ExternalAuthButton.vue?vue&type=template&id=5fd4ccc4"
import script from "./ExternalAuthButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExternalAuthButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExternalAuthButton.vue?vue&type=style&index=0&id=5fd4ccc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports